export const PRODUCTION_STATUS = Object.freeze({
  PRODUCED: "PRODUCED",
  CANCELLED: "CANCELLED",
});

export const PRODUCTION_STATUS_LABELS = Object.freeze({
  [PRODUCTION_STATUS.PRODUCED]: "Producida",
  [PRODUCTION_STATUS.CANCELLED]: "Anulada",
});

export const PRODUCTION_CALCULATION_MODE_LABELS = Object.freeze({
  FINAL_QUANTITY: "Cantidad final",
  INGREDIENT_QUANTITY: "Cantidad de insumo",
});

export const PRODUCTION_COMPONENT_TYPE_LABELS = Object.freeze({
  INGREDIENT: "Insumo",
  PREPARED_PRODUCT: "Elaborado",
});

function asNumber(value, fallback = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}

function asDecimal(value, fallback = "0.0000") {
  if (value === null || value === undefined || value === "") return fallback;
  return String(value);
}

function asNullableDecimal(value) {
  if (value === null || value === undefined || value === "") return null;
  return String(value);
}

export function normalizeProductionLine(line = {}) {
  return {
    ...line,
    id: asNumber(line.id),
    lineOrder: asNumber(line.lineOrder),
    componentId: asNumber(line.componentId),
    name: String(line.name || ""),
    unit: String(line.unit || ""),
    netQuantity: asDecimal(line.netQuantity),
    yieldFactor: asDecimal(line.yieldFactor),
    requiredQuantity: asDecimal(line.requiredQuantity),
    stockControlled: Boolean(line.stockControlled),
    stockBefore: asNullableDecimal(line.stockBefore),
    stockAfter: asNullableDecimal(line.stockAfter),
    purchaseItemId:
      line.purchaseItemId === null || line.purchaseItemId === undefined
        ? null
        : asNumber(line.purchaseItemId),
    unitCost: asDecimal(line.unitCost, "0.00000000"),
    lineCost: asDecimal(line.lineCost, "0.00"),
  };
}

export function normalizeProduction(production = {}) {
  return {
    ...production,
    id: asNumber(production.id),
    preparedProduct: {
      id: asNumber(production.preparedProduct?.id),
      name: String(production.preparedProduct?.name || ""),
      resultUnit: String(production.preparedProduct?.resultUnit || ""),
    },
    producedQuantity: asDecimal(production.producedQuantity),
    totalCost: asDecimal(production.totalCost, "0.00"),
    producedBy: String(production.producedBy || ""),
    producedAt: production.producedAt || null,
    cancelledBy: production.cancelledBy || null,
    cancelledAt: production.cancelledAt || null,
    basisIngredientId:
      production.basisIngredientId === null ||
      production.basisIngredientId === undefined
        ? null
        : asNumber(production.basisIngredientId),
    basisQuantity: asNullableDecimal(production.basisQuantity),
    recipe: production.recipe
      ? {
          id: asNumber(production.recipe.id),
          resultQuantity: asDecimal(production.recipe.resultQuantity),
        }
      : null,
    lines: Array.isArray(production.lines)
      ? production.lines.map(normalizeProductionLine)
      : [],
  };
}

export function normalizeProductionList(response = {}) {
  return {
    data: Array.isArray(response.data)
      ? response.data.map(normalizeProduction)
      : [],
    meta: {
      page: asNumber(response.meta?.page, 1),
      limit: asNumber(response.meta?.limit, 20),
      totalItems: asNumber(response.meta?.totalItems),
      totalPages: asNumber(response.meta?.totalPages),
      hasNextPage: Boolean(response.meta?.hasNextPage),
      hasPreviousPage: Boolean(response.meta?.hasPreviousPage),
    },
  };
}
